export type PricingListType = {
  id: number,
  sid: string,
  mode: number,
  type: number,
  size: number,
  outNo: string,
  items: {},
  totalFee: number,
  localFee: number,
  platform: number,
  pictures: string[],
  providerId: number,
  providerName: string,
  surveyorId: number,
  surveyorName: string,
  operatorRole: number,
  operatorId: number,
  operatorName: string,
  visits: number,
  createdAt: number
};


export type PricingDetailType = {

}

export type PricingDataType = {
  id: number,
  sid: string
  mode: number,
  type: number,
  size: number,
  outNo: string,
  items: {},
  totalFee: number,
  localFee: number,
  platform: number,
  pictures: string[],
  providerId: number,
  providerName: string,
  surveyorId?: number,
  surveyorName?: string,
  operatorRole: number,
  operatorId: number,
  operatorName: string,
  visits: number,
  createdAt: number
}

// 核价参数
export type PricingParams = {
  mode: number; // 救援模式，事故或非事故
  type: number; // 救援类型，乘用车或商用车
  outNo: string; // 报案号
  size: number; // 车型大小
  platform: number; // 平台[0:调度台,1:企业服务平台]
  localFee: number; // 当地报价
  pictures: string[]; // 图片信息oid
  providerId: number;  // 需要核价的企业id
  providerName: string; // 需要核价的企业name
  surveyorId?: number; // 察勘员id
  surveyorName?: string; // 察勘员id
};

export const ITEM_BASEMENT = 1;
export const ITEM_CRANE = 2;
export const ITEM_HS = 3;
export const ITEM_SR = 4;
export const ITEM_VT = 5;
export const ITEM_WHEEl = 6;
export const ITEM_OIL = 9;//送油
export const ITEM_ELECTRIFY = 10;//搭电
export const ITEM_TYRE = 11;//换轮胎
export const ITEM_CRANE1 = 12;
export const ITEM_DR = 13;//困境救援
export const ITEM_OTHER = 255;//其他服务项目 

export const ItemNamesMap: { [key: string]: string} = {
  [ITEM_BASEMENT]: "地库救援",
  [ITEM_CRANE]: "随车吊",
  [ITEM_HS]: "高速救援附加费",
  [ITEM_SR]: "现场救援",
  [ITEM_VT]: "车辆运输",
  [ITEM_WHEEl]: "辅助轮",
  [ITEM_OIL]: "送油",
  [ITEM_ELECTRIFY]: "搭电",
  [ITEM_TYRE]: "换胎",
  [ITEM_CRANE1]: "吊车",
  [ITEM_DR]: "困境救援",
  [ITEM_OTHER]: "其他费用",
};

export const ItemCodeMap: { [key: number]: string} = {
  [ITEM_BASEMENT]: "basement",
  [ITEM_CRANE]: "crane",
  [ITEM_VT]: "vt",
  [ITEM_CRANE1]: "crane1",
  [ITEM_SR]: "sr",
  [ITEM_WHEEl]: "wheel",
  [ITEM_OIL]: "oil",
  [ITEM_ELECTRIFY]: "electrify",
  [ITEM_TYRE]: "tyre",
  [ITEM_OTHER]: "other",
  [ITEM_DR]: "dr",
  [ITEM_HS]: "hs"
};

export type Basement = {
  sid: string;
  itemCode: number;
  itemName: string;
  tonnage?: number;
  daytime?: boolean;
};

// 起始地 送达地
export type Location = {
  longitude: string;
  latitude: string;
  province: string;
  city: string;
  district: string;
  address: string;
  name: string;
};

// 导航
export type Navagation = {
  map: number;
  distance: number;
  pair?: string;
  routesJsonSelected: string;
}

// 地址 & 导航
export type PriceAddress = {
  starting: Location;
  destination: Location;
  navigation: Navagation;
};

export type PriceWheel = {
  count: number;
};

// 添加服务项
export type PriceItemAdd = Basement | PriceAddress | PriceWheel;


// 基础救援
export const baseRescue = [ITEM_BASEMENT, ITEM_DR, ITEM_ELECTRIFY, ITEM_OIL, ITEM_TYRE];

export const baseRescueArr: {title: string, key: string }[]= baseRescue.map((el: number) => ({ title: ItemNamesMap[el], key: ItemCodeMap[el]}));


/* 
  数据返回
*/ 
export type PricingItemParams = Basement | PriceItemAdd | {
  starting: Location;
  destination: Location;
  navigation: Navagation;
};

export type Address = {
  address: string;
  city: string;
  createdAt: number;
  district: string;
  id: number;
  latitude: string;
  longitude: string;
  name: string;
  pair: string;
  province: string;
  type: number;
};

export type PriceItem = {
  id: number,
  sid: string,
  itemCode: number,
  itemName: string,
  dayTime: boolean,
  count: number,
  tonnage: number,
  totalFee: number,
  locationPair: string,
  createdAt: number
};

export type Navigation = {
  distance: number;
  id: string;
  map: number;
  pair: string;
  routesJsonSelected: string;
};

export type ViewItem = {
  starting: Address;
  destination: Address,
  navigation: Navigation;
  item: PriceItem;
};

export type PriceItemData= {
  [key: string]: ViewItem | null;
} & { vt: ViewItem[] | null };

// 提交的报案信息
export type SubPricingVal = {
  outNo: string;
  size: number;
  mode: number;
  type: number;
  providerId: number;
  localFee: string;
  surveyorId?: number;
};
